module.exports = __webpack_public_path__ + "static/media/cutomize-T-shirt-1.5bd6c210.png";